import imagesAdd from 'assets/image/icons/buttons/add-svg-white.svg'
import image from 'assets/image/welcome-snail.jpg'
import { ResponsiveButton } from 'components/atoms/responsiveButton/index.tsx'
import { CONSTS } from 'config/objectConst.js'

import { openInvite } from '../Wrapper/useInviteModal'
import css from './ModalNotTeam.module.scss'

const ModalNotTeam = () => (
	<article className={css.root}>
		<h2 className={css.title}>Welcome to {CONSTS.PROJECT_NAME} teams!</h2>
		<p className={css.description}>
			Here you can meet your teammates and have a great collaboration.
		</p>
		<ResponsiveButton
			className={`btn bold ${css.action}`}
			disabled={false}
			isLoading={false}
			onClick={openInvite}
		>
			<>
				<img alt='timeIcon' src={imagesAdd} />
				<span>Invite new member</span>
			</>
		</ResponsiveButton>
		<img alt='snail' className={css.img} src={image} />
	</article>
)

export default ModalNotTeam
